<template>
  <div class='informationPage'>
    <div class="news">
      <ul class="news_u" style="margin-top: 30px;">
        <li v-for="(item , index) in articleList" @click="goDetails(item)">
          <a>
            <div class="one">
              <img :src="item.image_url" alt="" v-if="item.image_url != '' ">
              <img src="https://www.verygrass.mo/data/article/1498027247886214852.jpg" v-else>
            </div>
            <div class="two">
              <h3>{{item.title}}</h3>
              <p>{{item.desc}}</p>
              <span>發布時間：{{item.created_at}}</span>
            </div>
          </a>
        </li>
      </ul>
      <!--分页-->

      <!--分页-->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize">
      </el-pagination>

    </div>
    <!--导航-->
    <div class="nav">
      <div class="m_nav">
        <div class="m_nav_l">
          <h3>極草資訊</h3>
        </div>
        <div class="m_nav_r">
          <ul>
            <li v-for="(item) in titleChild" :key="item.id" @click="getArticleId(item)">
              <a>{{item.name}}</a>
              <input type="hidden" :value="articleId">
            </li>
          </ul>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
  //api
//  import {journalism ,newsClassificationList} from '@/api/article';
  import {articleCats,articlesList} from '@/api/article';
  export default {
    name: 'InformationPage',
    components:{

    },
    data () {
      return {
        titleChild:[],
        //文章id
        articleId:this.$route.query.id ,
        //新闻列表
        articleList:[],
        //分页数据
        total:0,
        pageSize:0,
        page:1,
        // 详情title
        title:'',
      }
    },
    methods:{
        /*获取分类列表*/
        getJournalismList(){
          articleCats({parent_id:1}).then(res=>{
              this.titleChild = res.data.data;
              this.articleId= (res.data.data)[0].id;
              this.title= (res.data.data)[0].name;
              //文章列表
              this.listArticles();
          });
        },

      /*点击获取文章分类ID*/
      getArticleId(item){
        this.title = item.name
        this.$router.push({
          name:'InformationPage',
          query:{
            id:item.id
          }
        })
      },

      /*文章列表*/
      listArticles(){
//          var obj = {
//            include:'articlecat',
//            article: this.articleId
//          };
        articlesList({article_cat_id:this.articleId},this.page).then(res=>{
          this.total = res.data.meta.pagination.total;
          this.pageSize = res.data.meta.pagination.per_page;
          this.articleList = res.data.data;
        })
      },

      /*点击进入详情页*/
      goDetails(item){
        this.$router.push({
          name:'ArticleDetails',
          query:{
              id:item.id,
              title:this.title
         }
        })
      },

      handleSizeChange(val) {
      },
      handleCurrentChange(val) {
        this.page = val;
        //获取分类列表
        this.getJournalismList();
      }

    },
    created(){
        //获取分类列表
        this.getJournalismList();
      window.scrollTo(0,0)
    },
    watch : {
      '$route':{
        deep: true,
        handler: function(to, from){
          if(to.path == "/informationPage"){
            this.articleId = this.$route.query.id ;
            if(!this.articleId){
              this.articleId= this.titleChild[0].id;
              this.title= this.titleChild[0].name;
            }
            //文章列表
            this.listArticles();
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../css/informationPage.less";
</style>



// WEBPACK FOOTER //
// src/pages/article/Information/InformationPage.vue